<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-datepicker
              name="a_partire_dal"
              label="Data"
              v-model="filter.a_partire_dal"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>

    <!-- <export-options
      :exportUrl="exportUrl"
      :repository="repository"
      :resource="resource"
      :tableRef="$refs[tableRef]"
      :filter="filter"
      :options="[
        {
          code: 'EXCOGICO',
          label: null,
          formats: ['csv', 'pdf'],
        },
      ]"
    ></export-options> -->

    <exp-cash-entries-no-fc-table
      :fields="fields"
      :repository="repository"
      :resource="resource"
      @manualFetch="manualFetch"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :filterName="filterName"
      :filterOn="{
        byRelations: ['byBroker', 'byTreasury', 'byCashReference'],
      }"
      :ref="tableRef"
      :previous_balance_date="previous_balance_date"
      :previous_balance="previous_balance"
      :current_balance_date="filter.fino_al"
      :current_balance="current_balance"
      type="exp-cash-entry"
      noActions
    ></exp-cash-entries-no-fc-table>

    <b-row>
      <b-col align="right">
        <b-button
          class="btn-create"
          type="button"
          variant="lisaweb"
          size="sm"
          @click="registraTotale()"
          title="Registra Totale"
          :disabled="!itemCount || totaleSaldo == 0"
        >
          <b-icon icon="cash-stack" aria-hidden="true"></b-icon>
          Registra Totale
        </b-button>
      </b-col>
    </b-row>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
// import CashEntriesTable from "@/components/tables/CashEntry.vue";
import ExpCashEntriesNoFcTable from "@/components/tables/ExpCashEntryNoFc.vue";
// import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapActions, mapGetters } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { today } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
// import ExportOptions from "@/components/ExportOptions";
import moment from "moment";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

moment.locale("it");
export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      tableRef: "CashEntriesNoFcTableRef",
      filterName: "filterControlloNoFoglioCassa",
      cash_references_opt: [],
      treasuries_opt: [],
      companies: [],
      contoPrimaNota: "PNC",
      causaleRegTotEntr: "TIE",
      causaleRegTotUsc: "TIU",
      performedSearch: false,
      activeFilters: {},
      idCausalePrimaNotaEntr: null,
      idCausalePrimaNotaUsc: null,
      cashEntryTypeEntr: null,
      cashEntryTypeUsc: null,
      filter: this.initFilter(),
      previous_balance_date: null,
      previous_balance: {},
      current_balance: {},
      fields: [
        {
          key: "conto.codice",
          label: this.getDictionary("Conto"),
        },
        {
          key: "data_registrazione",
          formatter: (value) => toLocaleDate(value),
          label: this.getDictionary("cash_time", "cash_entry"),
        },
        {
          key: "produttore.title",
          label: this.getDictionary("salesman"),
        },
        {
          key: "causale",
          label: this.getDictionary("cash_reference_id", "cash_entry"),
          formatter: (value) => `${value.codice} - ${value.descrizione}`,
        },
        {
          key: "descrizione",
          label: this.getDictionary("title", "cash_entry"),
        },
        {
          key: "id_compagnia",
          label: "Compagnia",
          formatter: (value) => this.retriveInsurer(value),
        },
        {
          key: "entrate",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 0)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return toLocaleCurrency(0);
          },
          label: this.getDictionary("entry_in", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
        },
        {
          key: "uscite",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 1)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return toLocaleCurrency(0);
          },
          label: this.getDictionary("entry_out", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
        },
      ],
      itemCount: null,
      totaleEntrate: null,
      totaleSaldo: null,
      totaleUscite: null,
    };
  },
  components: {
    // CashEntriesTable,
    ExpCashEntriesNoFcTable,
    // BaseSelect,
    BaseIcon,
    BaseDatepicker,
    // ExportOptions,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.itemCount = null;
      this.totaleEntrate = null;
      this.totaleSaldo = null;
      this.totaleUscite = null;
      this.previous_balance_date = null;
      this.previous_balance = {};
      this.current_balance = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    registraTotale() {
      console.log("registraTotale");
      const Repo = RepositoryFactory.get(this.repository);
      let payload = {
        cash_entry_type:
          this.totaleSaldo > 0 ? this.cashEntryTypeUsc : this.cashEntryTypeEntr,
        data_registrazione: this.filter.a_partire_dal,
        id_causale_prima_nota:
          this.totaleSaldo > 0
            ? this.idCausalePrimaNotaUsc
            : this.idCausalePrimaNotaEntr,
        id_conto_prima_nota: this.filter.conto,
        importo: Math.abs(+this.totaleSaldo),
      };
      Repo.store(payload)
        .then((response) => {
          console.log("response", response);
          // this.$refs[this.tableRef].isLoading = true;
          // this.$refs[this.tableRefComparison].isLoading = true;
          // this.isLoadingComparison = true;
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    retriveInsurer(value) {
      let insurer_text = "";
      this.companies.forEach((company) => {
        if (company.value === value) insurer_text = company.text;
      });
      return insurer_text;
    },
    initFilter() {
      let init = {
        a_partire_dal: today(),
        fino_al: today(),
        produttore: null,
        causale: null,
        conto: null,
        compagnia: [],
        foglio_cassa_compagnia: 0,
      };
      return init;
    },
    // customFilterName(key, prefix = "byAttribute") {
    //   return `${prefix}.${key}`;
    // },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // this.$refs[this.tableRef].sortBy = "data_registrazione";
      // this.$refs[this.tableRef].sortAsc = true;
      this.fetch();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["conto"];
      delete this.activeFilters["foglio_cassa_compagnia"];

      return this.activeFilters;
    },
    fetch(name) {
      if (this.filter.a_partire_dal && this.filter.conto) {
        this.filter.fino_al = this.filter.a_partire_dal;
        let criteria = this.filter;
        this.saveFilterByName({ name, criteria });
        this.removePaginationByName(name);
        return this.$refs[this.tableRef]
          .fetch({ verb: { name: "listaMovimenti", alias: "index" } })
          .then(() => {
            // Used this to enable/disable the button
            this.itemCount = this.$refs[this.tableRef]?.items?.length ?? null;
            this.fetchSummary();
          });
      } else {
        if (!this.filter.conto) {
          this.$showSnackbar({
            preset: "error",
            text: `Attenzione: non risulta alcun conto collegato`,
          });
        } else {
          this.$showSnackbar({
            preset: "success",
            text: `Devi impostare una data`,
          });
        }
      }
    },
    fetchSummary() {
      this.$refs[this.tableRef].isLoading = true;
      const Repo = RepositoryFactory.get(this.repository);
      // Previous Balance
      this.previous_balance_date = moment(this.filter.a_partire_dal)
        .subtract(1, "d")
        .format("YYYY-MM-DD");
      const byBroker = this.filter.produttore
        ? `&produttore=${this.filter.produttore}`
        : "";
      const byCashReference = this.filter.causale
        ? `&causale=${this.filter.causale}`
        : "";
      const queryString = `a_partire_dal=${this.filter.a_partire_dal}&fino_al=${this.filter.fino_al}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
      Repo.saldoContoNoFoglioCassa(queryString)
        .then((response) => {
          this.previous_balance = response.data;
          this.current_balance = response.data;
          // Current Balance
          // const queryString = `a_partire_dal=${this.filter.a_partire_dal}&fino_al=${this.filter.fino_al}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
          // Repo.summary(queryString)
          // .then((response) => {
          console.log("response", response);
          const data = response?.data;
          this.totaleEntrate = data?.entrate;
          this.totaleSaldo = data?.saldo;
          this.totaleUscite = data?.uscite;
          this.$refs[this.tableRef].isLoading = false;
          // })
          // .catch((error) => {
          //   let errMsg = this.$getErrorMessage(error);
          //   this.$showSnackbar({
          //     preset: "error",
          //     text: `${errMsg}`,
          //   });
          //   this.$refs[this.tableRef].isLoading = false;
          // });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.$refs[this.tableRef].isLoading = false;
        });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getInsurers: "insurers",
      getCashReferences: "cash_references",
      getContiPrimaNota: "allContiPrimaNota",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("insurers")) {
      resources.push(
        this.$store
          .dispatch(`${path}insurers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.companies = this.getInsurers();
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.companies = this.getInsurers();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
    let cashReferences = this.getCashReferences();
    const found_causale_entr = cashReferences.find(
      (el) => el.text === this.causaleRegTotEntr,
    );
    const found_causale_usc = cashReferences.find(
      (el) => el.text === this.causaleRegTotUsc,
    );
    if (
      found_causale_entr &&
      found_causale_entr?.value != null &&
      found_causale_entr?.entry_type != null
    ) {
      this.idCausalePrimaNotaEntr = found_causale_entr.value;
      this.cashEntryTypeEntr =
        found_causale_entr.entry_type == 1 ? "Uscita" : "Entrata";
    }
    if (
      found_causale_usc &&
      found_causale_usc?.value != null &&
      found_causale_usc?.entry_type != null
    ) {
      this.idCausalePrimaNotaUsc = found_causale_usc.value;
      this.cashEntryTypeUsc =
        found_causale_usc.entry_type == 1 ? "Uscita" : "Entrata";
    }
    cashReferences.sort((a, b) => a.text - b.text);
    cashReferences.forEach((el) => {
      this.cash_references_opt.push({
        text: `${el.text} - ${el.description}`,
        reference_type: el.reference_type,
        has_broker: el.has_broker,
        has_company: el.has_company,
        entry_type: el.entry_type,
        value: el.value,
        treasury_id: el.treasury_id,
      });
    });
    /* */
    this.treasuries_opt = this.getContiPrimaNota();
    this.filter.conto = this.treasuries_opt.find(
      (treasury) => treasury.code === this.contoPrimaNota,
    )?.value;
  },
  beforeMount() {
    this.removeFilterByName(this.filterName);
  },
};
</script>
